export default __webpack_public_path__ + "8b72ac3171077e4007dd9cbcf5c4f8dd.woff";